<template>
    <div>
        <title-component></title-component>
        <div class="col-12 col-sm-12">
            <card-title-component :title="$t('links.immediate-aid-title')"></card-title-component>
            <div class="card-content">
                <div class="row">
                    <div class="col">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div>
                            Link 1
                        </div>
                        <div>
                            Link 2
                        </div>
                        <div>
                            Link 3
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12">
            <card-title-component :title="$t('links.pension-title')"></card-title-component>
            <div class="card-content">
                <div class="row">
                    <div class="col">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div>
                            Link 1
                        </div>
                        <div>
                            Link 2
                        </div>
                        <div>
                            Link 3
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12">
            <card-title-component :title="$t('links.advance-decision-title')"></card-title-component>
            <div class="card-content">
                <div class="row">
                    <div class="col">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div>
                            Link 1
                        </div>
                        <div>
                            Link 2
                        </div>
                        <div>
                            Link 3
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TitleComponent from './shared/TitleComponent'
    import CardTitleComponent from './ui/card/CardTitleComponent'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Links',
        metaInfo () { return {title: i18n.t('links.meta')} },
        components: {
            'title-component': TitleComponent,
            'card-title-component': CardTitleComponent
        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';
</style>



// WEBPACK FOOTER //
// src/components/LinksComponent.vue